// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledTypography } from "@rpsc/MobiusOverrides/Link/Link";
import { categoriesStyles } from "@rpsc/Overrides/Widgets/BrandDetails/BrandDetailsCategories";
import IconArrowRightLink from "@rpsc/XDL/Icons/IconArrowRightLink";
import IconPlus from "@rpsc/XDL/Icons/IconPlus";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, createLinkIconStyles, ellipsis, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

categoriesStyles.title = {
    variant: "h4",
    css: css`
        margin-bottom: 32px;
    `,
};

categoriesStyles.container = {
    css: css`
        margin: 30px 15px;
    `,
};

categoriesStyles.categoryContainer = {
    css: css`
        display: flex;
        margin: 0;
        gap: 24px 20px;
        flex-wrap: wrap;
        ${xScreen("lte", "sm")} {
            gap: 24px 16px;
        }
        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};

categoriesStyles.innerCategoryContainer = {
    css: css`
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        margin: 0;
        flex-basis: 198px;
        ${xScreen("lte", "md")} {
            flex-basis: 166px;
        }
        ${xScreen("lte", "sm")} {
            flex-basis: 152px;
        }
    `,
};

categoriesStyles.categoryImageItem = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};

categoriesStyles.categoryImage = {
    width: "143px",
    height: "143px",
    css: css`
        border: 1px solid ${color("common.border")};
        border-radius: 2px;
        ${xScreen("lte", "xs")} {
            width: 120px;
            height: 120px;
        }
    `,
};

categoriesStyles.categoryNameLink = {
    mergeCss: true,
    typographyProps: {
        size: 15,
        weight: fontConfig.weight.bold,
    },
    color: "text.main",
    css: css`
        width: 100%;
        letter-spacing: 0;
        text-align: center;
        margin-top: 11px;
        justify-content: center;
        ${StyledTypography} {
            line-height: ${fontConfig.lineHeight.small};
        }
        ${ellipsis(2)};
    `,
};

categoriesStyles.subCategoryItem = {
    css: css`
        padding-top: 2px;
        padding-bottom: 3px;
        text-align: center;
    `,
};

categoriesStyles.subCategoryLink = {
    mergeCss: true,
    typographyProps: {
        color: "text.main",
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
        `,
    },
    css: css`
        text-align: center;
    `,
};

categoriesStyles.viewMoreLinkItem = {
    width: 12,
    css: css`
        padding-top: 5px;
        display: flex;
        justify-content: center;
    `,
};

categoriesStyles.viewMoreLink = {
    ...createLinkIconStyles(
        IconPlus,
        {
            typographyProps: {
                size: 12,
                lineHeight: "14px",
                weight: fontConfig.weight.bold,
            },
            icon: { iconProps: { size: 9 } },
        },
    ),
};
